import { Component, Input } from '@angular/core';
import { FileDownloadModel } from 'src/app/models/api/fileDownload.model';
import { ISelectedFilters } from 'src/app/models/filters/selectedFilters.interface';
import { SortColumn } from 'src/app/models/sortColumn.model';
import { HttpErrorHandlerService } from 'src/app/services/httpServices/httpErrorHandlerService/http-error-handler.service';
import { InventoryHttpService } from 'src/app/services/httpServices/inventoryHttpService/inventory-http.service';

@Component({
  selector: 'app-inventory-export',
  templateUrl: './inventory-export.component.html',
  styleUrls: ['./inventory-export.component.scss'],
})
export class InventoryExportComponent {
  @Input() public selectedFilters: ISelectedFilters;
  @Input() public sort?: SortColumn;

  public waitingForFile = false;
  public displayCheckMark = false;

  constructor(
    private readonly _inventoryHttpService: InventoryHttpService,
    private readonly _httpErrorHandlerService: HttpErrorHandlerService
  ) {}

  public exportToCSV(): void {
    this.waitingForFile = true;
    this._inventoryHttpService.exportFilteredResources(this.selectedFilters, this.sort).subscribe(
      (response: FileDownloadModel) => {
        // This will trigger the download
        window.open(response.fileUrl);
        this.waitingForFile = false;
      },
      (error) => {
        this.waitingForFile = false;
        this._httpErrorHandlerService.handle(error);
      }
    );
  }
}
